// HelpCard.js
import React from 'react';
import './HelpCard.css';

const HelpCard = () => {
  return (
    <div className="help-card">
      <h2>Process Overview</h2>
      <div className="process-graph">
        <div className="node">
          <div className="circle">1</div>
          <p>Enroll your organization's admin users</p>
        </div>
        <div className="arrow">→</div>
        <div className="node">
          <div className="circle">2</div>
          <p>Add your API keys, enable or disable your Carriers</p>
        </div>
        <div className="arrow">→</div>
        <div className="node">
          <div className="circle">3</div>
          <p>For the enabled carriers, import those drivers</p>
        </div>
        <div className="arrow">→</div>
        <div className="node">
          <div className="circle">4</div>
          <p>Enable and disable drivers</p>
        </div>
      </div>
    </div>
  );
};

export default HelpCard;